export default "__VITE_ASSET__B0aq3RLA__"